import * as React from 'react';
import type { SVGProps } from 'react';
const FileSpreadsheet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#01AC49"
      fillRule="evenodd"
      d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm12.391 16.672q.225-.08.528-.343.45-.383.436-.687 0-.303-.37-.712l-2.54-2.967 2.54-2.96q.37-.396.37-.713.013-.316-.436-.7-.29-.276-.515-.356a.54.54 0 0 0-.435.026q-.212.105-.462.41l-2.37 2.766L9.648 7.67q-.25-.305-.462-.41a.54.54 0 0 0-.436-.026q-.224.08-.514.356-.435.384-.436.7 0 .317.37.713l2.54 2.96-2.54 2.967q-.37.409-.37.712 0 .304.436.687.303.264.528.343.224.08.435-.027.211-.105.449-.395l2.37-2.762 2.369 2.762q.25.29.449.395.21.106.435.027"
      clipRule="evenodd"
    />
  </svg>
);
export default FileSpreadsheet;

